@defer (when value()) {
  <app-permissions-form
    [edit]="false"
    [details]="true"
    [(value)]="value"
    [id]="id"
    [access]="access()"
  ></app-permissions-form>
}
